import React from "react";
import { Control } from "react-hook-form";
import { FormInputNumber } from "../../../../components/ui/Input/FormInputNumber/FormInputNumber";

interface IngredientTableProps {
  ingredientList: any[];
  control: Control<any>;
  validateTotalValue: (id: string, value: string) => boolean;
  validateRecipeValuePercent: (value: any) => boolean | string;
  validationError: { id: string; error: string };
  getSupplierName: (supplierData: any, ingredientId: string, supplierId: string) => string;
  suppliers: any;
  disabled?: boolean;
}

/**
 * Separate component for rendering ingredient table
 * Follows Single Responsibility Principle - only renders ingredient table
 */
export const RecipeIngredientTable: React.FC<IngredientTableProps> = ({
  ingredientList,
  control,
  validateTotalValue,
  validateRecipeValuePercent,
  validationError,
  getSupplierName,
  suppliers,
  disabled = false
}) => {
  if (!ingredientList || ingredientList.length === 0) {
    return null;
  }

  return (
    <div className="tw-space-y-3">
      <h3 className="tw-text-sm tw-font-semibold tw-text-gray-700 tw-uppercase tw-tracking-wide">
        Ingredient (s)
      </h3>
      <div className="tw-overflow-x-auto tw-rounded-lg tw-border tw-border-gray-200">
        <table className="tw-min-w-full tw-divide-y tw-divide-gray-200">
          <thead className="tw-bg-gray-50">
            <tr>
              <th className="tw-px-3.5 tw-py-3.5 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider tw-w-1/3">
                Name
              </th>
              <th className="tw-px-3.5 tw-py-3.5 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider tw-w-1/3">
                Supplier
              </th>
              <th className="tw-px-3.5 tw-py-3.5 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider tw-w-1/3">
                Value %
              </th>
            </tr>
          </thead>
          <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
            {ingredientList.map((ingredient: any) => (
              <tr
                className="tw-border-b hover:tw-bg-gray-50"
                key={ingredient?.data?.reference?.ingredientId}
              >
                <td className="tw-px-3.5 tw-py-2.5">
                  <p className="tw-text-sm tw-text-gray-700">{ingredient?.data?.label}</p>
                </td>
                <td className="tw-px-3.5 tw-py-2.5">
                  <p className="tw-text-sm tw-text-gray-700">
                    {getSupplierName(
                      suppliers,
                      ingredient?.data?.reference.ingredientId,
                      ingredient?.data?.reference?.supplierId
                    )}
                  </p>
                </td>
                <td className="tw-px-3.5 tw-py-2.5">
                  <FormInputNumber
                    name={
                      `ingredient-${ingredient?.data?.reference?.supplierId}-${ingredient?.data?.reference?.ingredientId}.value` as any
                    }
                    onChangeFunction={(e: any) => {
                      validateTotalValue(ingredient?.data?.reference?.ingredientId, e.target.value);
                    }}
                    placeholder="Enter value %"
                    control={control}
                    label=""
                    required={true}
                    errorMessage="This field is required"
                    enableMinus={false}
                    rules={{
                      validate: {
                        valueCheck: (v: any) => validateRecipeValuePercent(v)
                      }
                    }}
                    disabled={disabled}
                  />
                  {validationError.id === ingredient?.data?.reference?.ingredientId && (
                    <span className="tw-text-red-600 tw-text-xs tw-mt-1 tw-block">{validationError.error}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
